import baseStore from '../generic_store';

const base = baseStore('statuses');

const state = {
    ...base.state,
    base_url: '/api/statuses',
    resourceName: 'Statut',
    model: {
        translatable: {
            name: {
                fr: '',
                en: ''
            },
        },
        name: {
            fr: '',
            en: ''
        },
    },
};

const getters = {
    ...base.getters,
};

const actions = {
    ...base.actions,
};

const mutations = {
    ...base.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

